import React, { useState, useMemo, useEffect } from "react";
import { ReactComponent as BackArrow } from "../../assets/navbar/BackArrow.svg";
import { ReactComponent as Trash } from "../../assets/analyse/Trash.svg";
import { ReactComponent as Plus } from "../../assets/analyse/Plus.svg";

import DropdownList from "react-widgets/DropdownList";
import countryList from "react-select-country-list";
import "react-widgets/styles.css";
import "react-toastify/dist/ReactToastify.css";
import ComponentLoading from "../../commonComponents/ComponentLoading";
import LossComponent from "./LossComponent";
import { Tooltip, TooltipProps, tooltipClasses } from "@mui/material";

// REDUX
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { uploadFiles, setExtractedData } from "../../redux/actions/analysisActions";

// utils
import MainButton from "../../commonComponents/MainButton";
import UploadDocuments from "./UploadDocuments";
import DrawDocumentAi from "./DrawDocumentAi";
// import pdfjsLib from "pdfjs-dist/build/pdf";
import { PDFToImage } from "react-pdf-to-image-light";
import DocumentForm from "./DocumentForm";

const UploadPanel = ({ setShowUploadPanel, step_index }) => {
  // REDUX DATA
  // const flow_type_meta = useSelector((state) => (state.flow.flow_type_meta ? state.flow.flow_type_meta : null));
  // const analysis_id = useSelector((state) => (state.analysis.analysis_id ? state.analysis.analysis_id : null));
  // const analysis_data = useSelector((state) => state.analysis.analysis_data, shallowEqual); //? state.analysis.analysis_data : null)
  // const impact_indicators = useSelector((state) => (state.analysis.impact_indicators ? state.analysis.impact_indicators : null));
  // const user_info = useSelector((state) => (state.user.user_info ? state.user.user_info : null));

  const extracted_data = useSelector((state) => (state.analysis ? state.analysis.extracted_data : null));

  // REDUX ACTIONS
  const dispatch = useDispatch();
  const setExtractedData_rd = (item) => dispatch(setExtractedData(item));

  // LOCAL VARIABLES
  const [loading, setLoading] = useState(true);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(0);


  const [fileList, setFileList] = useState();
  const files = fileList ? [...fileList] : [];


  const handleNextDocument = () => {
    // const doc_index = Object.values(extracted_data[step_index]).indexOf(selectedDocument);
    if (selectedIndex === Object.keys(extracted_data[step_index]).length - 1) {
      // setSelectedDocument(extracted_data[step_index][0]);
      setSelectedIndex(0);
    } else {
      // setSelectedDocument(extracted_data[step_index][doc_index + 1]);
      setSelectedIndex(selectedIndex + 1);
    }
  };

  const handlePreviousDocument = () => {
    // const doc_index = Object.values(extracted_data[step_index]).indexOf(selectedDocument);
    if (selectedIndex !== 0) {
      // setSelectedDocument(extracted_data[step_index][doc_index - 1]);
      setSelectedIndex(selectedIndex - 1);
    } else {
      // setSelectedDocument(extracted_data[step_index][doc_index + 1]);
      setSelectedIndex(selectedIndex + 1);
    }
  };

  return (
    <div className="w-full h-full z-40">
      <div className="fixed right-0 top-[70px] bg-white h-[750px] w-[1000px] border-[#F3F5F7] border-[0.1px]">
        {/* HEADER */}
        <div className={`border-[#F3F5F7] border-b-[1px] ml-[30px] mr-[90px]`}>
          <div className="w-full flex justify-between items-center">
            <div className="h-[70px] flex items-center justify-start font-Poppins-SemiBold text-lg">{"Importer des données"}</div>
            <button
              className="flex justify-between w-[100px]"
              onClick={() => {
                setShowUploadPanel(false);
              }}
            >
              <p className="text-gray-400 font-Poppins-SemiBold">Retour</p>
              <BackArrow transform="rotate(180)" />
            </button>
          </div>

          {/* LOSS */}
          {/* {loss && !data.name && <LossComponent total_loss={get_total_loss(loss, raw_to_cooked)} loss={loss} raw_to_cooked={raw_to_cooked} raw_to_cooked={raw_to_cooked} />} */}
        </div>

        {/* {extracted_data && extracted_data[step_index] && Object.keys(extracted_data[step_index]).length > 1 ? ( */}
        {extracted_data && extracted_data[step_index] && extracted_data[step_index][selectedIndex] && extracted_data[step_index][selectedIndex].selected_entities && Object.keys(extracted_data[step_index]).length > 1? (
          <>
            <div className="h-[40px] w-[180px] flex justify-center ml-[220px]">
              <button onClick={handlePreviousDocument}>
                <BackArrow transform="" />
              </button>

              <div className="py-[10px] w-[200px] justify-center items-center flex flex-col">
                <p className="font-Poppins-SemiBold">{"File " + (selectedIndex + 1)}</p>
              </div>

              <button
                onClick={handleNextDocument}
                // disabled={extracted_data.length === 1}
              >
                <BackArrow transform="rotate(180)" />
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="h-[40px] w-[180px] flex justify-center ml-[220px]" />
          </>
        )}

        
        {extracted_data && extracted_data[step_index] && extracted_data[step_index][selectedIndex] && extracted_data[step_index][selectedIndex].selected_entities ? (
          <div className="w-full h-full flex flex-row">
            <div className="flex w-[600px] h-[600px]">
              <DrawDocumentAi
                // imageData={extracted_data[0].image}
                imageData={extracted_data[step_index][selectedIndex].image}
                imageSize={{ width: 1080, height: 1080 }}
                entities={extracted_data[step_index][selectedIndex].entities}
                hilight={extracted_data[step_index][selectedIndex].entities[0]}
                entityOnClick={() => {
                  console.log("entity click !");
                }}
              />
            </div>
            <DocumentForm selectedIndex={selectedIndex} step_index={step_index} setLoading={setLoading}/>
          </div>
        ) : (
          <UploadDocuments step_index={step_index} />
        )}
      </div>
    </div>
  );
};

export default UploadPanel;
